module.exports = __webpack_public_path__ + "img/smartphone.9645c2fa.svg";